
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19","height":"19"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"d":"M0 0h18.47v18.47H0z"}})])]),_c('path',{attrs:{"fill":"#2dc98a","d":"M9.553 6.56H7.54v2.564h2.013c.882 0 1.42-.51 1.42-1.296 0-.744-.538-1.268-1.42-1.268"}}),_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"fill":"#2dc98a","d":"M18.47 0v18.47H0V0zM9.716 11.02c2.137 0 3.488-1.28 3.488-3.222 0-1.9-1.31-3.181-3.391-3.181h-4.55v9.226H7.54V11.02z"}})])])
          )
        }
      }
    